<template>
  <!-- ACTIVE LISTINGS -->
  <div class="active-listings-inner" id="availability">
    <span class="subheading-small font-merriweather"> Active Listings &amp; Units </span>
    <div class="listings-tabs-container">
      <button style="height: 50px"
        v-bind:class="{ 'btn-light border-custom tabletSmall:btn-light-small': activeTab !== 'ACTIVE SALES', 'btn-dark tabletSmall:btn-dark-small': activeTab === 'ACTIVE SALES' }"
        @click="() => { activeTab = 'ACTIVE SALES'; window.googleAnalytics('grid_tabs', 'ACTIVE SALES'); }">
        ACTIVE SALES
        <span v-if="djangoData.available_sales_num != 0">&nbsp; ({{ djangoData.available_sales_num }})</span>
      </button>

      <button style="height: 50px"
        v-bind:class="{ 'btn-light border-custom tabletSmall:btn-light-small': activeTab !== 'ACTIVE RENTALS', 'btn-dark tabletSmall:btn-dark-small': activeTab === 'ACTIVE RENTALS' }"
        @click="() => { activeTab = 'ACTIVE RENTALS'; window.googleAnalytics('grid_tabs', 'ACTIVE RENTALS'); }">
        ACTIVE RENTALS
        <!-- <span v-if="djangoData.available_rentals_num != 0">&nbsp; ({{ djangoData.available_rentals_num }})</span> -->
      </button>

      <button style="height: 50px"
        v-bind:class="{ 'btn-light border-custom tabletSmall:btn-light-small': activeTab !== 'SOLD LISTINGS', 'btn-dark tabletSmall:btn-dark-small': activeTab === 'SOLD LISTINGS' }"
        @click="() => { activeTab = 'SOLD LISTINGS'; window.googleAnalytics('grid_tabs', 'SOLD LISTINGS'); }">
        SOLD LISTINGS
      </button>

      <button style="height: 50px"
        v-bind:class="{ 'btn-light border-custom tabletSmall:btn-light-small': activeTab !== 'ALL UNITS', 'btn-dark tabletSmall:btn-dark-small': activeTab === 'ALL UNITS' }"
        @click="() => { activeTab = 'ALL UNITS'; window.googleAnalytics('grid_tabs', 'ALL UNITS'); }">
        ALL UNITS
      </button>

    </div>
    <!-- GRID DESKTOP VERSION -->
    <div class="grid-desktop-version">
      <ag-grid-vue id="soldListings" class="ag-theme-alpine" :style="{ height: gridHeight, width: '100%' }"
        :column-defs="listingsColumnDefs" :row-data="rowData" :row-animation="true" :default-col-def="gridDefaultColDef"
        :tooltip-show-delay="500" :tooltip-hide-delay="10000" @grid-ready="onGridReady"
        :loading="gridLoading" no-rows-overlay-component="NoRowsOverlay" :no-rows-overlay-component-params="{tab: activeTab}"
        :suppress-context-menu="true" v-bind="window.agGridGenericOptions()">
      </ag-grid-vue>
    </div>
    <!-- GRID MOBILE VERSION -->
    <div class="grid-mobile-version">
      <div class="mobile-listing-unit"
        v-for="{ pk, photos, unit, price, beds, baths, 'square feet': square_feet, price_per_sqft, show_all_imgs, cta_text, cta_value } in rowData">
        <div class="mobile-listing-imgs-container"
          v-if="(activeTab === 'ACTIVE SALES' || activeTab === 'ACTIVE RENTALS') && photos && photos.length">
          <div v-if="show_all_imgs" class="all-imgs-container">
            <img v-for="img in photos" :src="img" loading="lazy" />
          </div>
          <div v-else class="single-image-container">
            <img :src="photos[0]" loading="lazy" :alt="'Image for' + unit" />
            <button @click="toggleShowImgs(pk)" class="cursor-pointer mobile-show-more-imgs-btn">
              <span class="material-symbols-outlined text-white"> chevron_right </span>
            </button>
          </div>
        </div>
        <span v-else-if="activeTab === 'ACTIVE SALES' || activeTab === 'ACTIVE RENTALS'">No Photos Available</span>
        <div class="mobile-listing-content-container">
          <div>
            <span class="block font-weight-normal">{{ unit }}</span>
            <span>{{ price }}</span>
            <div style="display: flex; column-gap: 4px"><span class="font-weight-normal">{{ beds }} </span> <span> Beds,
              </span> <span class="font-weight-normal">{{ baths }}</span> <span> Baths </span></div>
            <div style="display: flex; column-gap: 4px"><span class="font-weight-normal">{{ square_feet }}</span> <span>
                Square Feet {{ cta_value }}</span></div>
          </div>
          <div>
            <button @click="attachCtaValue(cta_value)" class="btn-dark-small"> {{ cta_text }} </button>
          </div>
        </div>
        <hr class="mt-4" />
      </div>
      <span v-if="!rowData || rowData.length === 0">No Data</span>
    </div>
  </div>
  <!-- STACKING PLANS -->
  <div v-if="djangoData.is_new_development && djangoData.building_unit_count" class="stacking-plans" id="residences">
    <span class="subheading-small font-merriweather"> {{ djangoData.name }} Residences </span>
    <div class="filters">
      <prime-select v-model="status" :options="statusOptions" placeholder="Status" show-clear style="width: 200px">
      </prime-select>
      <prime-select v-model="beds" :options="bedOptions" option-label="name" placeholder="Beds" show-clear
        style="width: 200px"> </prime-select>
    </div>

    <div class="stacking-content">
      <div v-for="(data, index) in stackingPlan" class="stack-row">
        <span class="stack-floor" v-if="data[0].floor == 0">Floor G</span>
        <span class="stack-floor" v-else>Floor {{ data[0].floor }}</span>
        <div class="row-stacks">
          <div v-for="stack in data" :style="{ width: unitArea(stack) }" class="row-stack-btn"
            @click="(window.stopPropagation($event), openStackingPopup(stack))" role="button" aria-label="Open Stacking Plan">
            <button class="stack-box w-full" :style="stackBGcolor(stack, index)" aria-label="Open Stacking Plan">
              <span :style="stackContent(stack)">{{ stack.unit }}</span>
              <span :style="stackContent(stack)" v-if="stack.beds.length || stack.baths.length">{{ stack.beds }}br/{{ stack.baths }}ba</span>
              <span :style="stackContent(stack)" v-else-if="stack.square_feet != null">{{
                formatWithCommas(stack.square_feet) }} sqft</span>
            </button>
          </div>
        </div>
      </div>
      <div v-if="stackingPlan.length === 0 && stackingPlanLoading === false">No units found</div>
      <div v-if="stackingPlanLoading">Data loading...</div>
    </div>
  </div>
  <!-- POP UP FOR FLOOR PLAN -->
  <dialog-component v-model="openFloorplanPopup" @click.stop="" title="" :hide-footer="true" :style="{ width: '70vw' }">
    <div class="flex flex-col items-center">
      <a :href="selectedStack.floor_plan" target="_blank">
        <img :src="selectedStack.floor_plan" loading="lazy"
          style="max-width: 100%; max-height: 604px; object-fit: contain; border: solid 1px #707070" />
      </a>
      <div class="popup-content">
        <div style="font-weight: normal">
          <span style="font-size: 24px; font-weight: 600" class="block popup-unit-name">{{ selectedStack.unit }},
            {{ selectedStack.status }}</span>
          <div>
            <span>{{ selectedStack.beds }} </span><span style="font-weight: 600"> beds, </span>
            <span>{{ selectedStack.baths }} </span><span style="font-weight: 600"> baths, </span>
            <span>{{ formatNumberWithCommas(selectedStack.square_feet) }} </span><span style="font-weight: 600">
              SqFt.</span>
          </div>
          <div>
            <span v-if="selectedStack.price" style="font-weight: 600">Initial Offering Price: </span> <span v-if="selectedStack.price" >{{ currencyFormatter({
              value:
                selectedStack.price
            }) }}, </span>
            <span v-if="selectedStack.sold"> {{ reformatDateInString(selectedStack.sold) }} </span>
          </div>
        </div>
        <div @click="openPlanForm(selectedStack)" class="popupSchduleViewingBtn cursor-pointer" role="button"> Request more info </div>
      </div>
    </div>
  </dialog-component>

  <div class="recent-activity" id="activity">
    <span class="subheading-small font-merriweather"> Recent Activity at <em>{{ djangoData.name }}</em> </span>
    <hr class="top-border" />
    <div class="recent-activity-content">
      <div style="margin-bottom: 8px"><span class="date-heading">Date</span><span class="unit-heading">Unit</span><span
          class="action-heading">Action</span></div>
      <div class="recent-activity-item" v-for="item in recentActivity"><span class="date text-base">{{ item.date }}</span>
        <span class="unit text-base">{{ item.unit }}</span> <span class="price text-base">{{ item.price }}</span>
      </div>
    </div>
    <hr class="bottom-border" />
    <div class="w-full flex justify-center gap-2">
      <button v-if="recentActivity.length > 10" class="btn-dark tabletSmall:btn-dark-small" id="recent-activity-view-more"
        onclick="toggleRecentActivity()">View More</button>
      <button class="btn-dark tabletSmall:btn-dark-small"
        onclick="showCustomDialog('save-subscriber-dialog'), window.googleAnalytics('subscribe_for_updates', 'Recent Activity')">
        Subscribe for Updates
      </button>
    </div>
  </div>
  <div v-if="djangoData.is_new_development && djangoData.floor_plan_count" class="floor-plans" id="floorplans">
    <span class="subheading-small font-merriweather"> Apartment Floor Plans </span>
    <div class="floor-plan-items">
      <button class="floor-item box-shadow" v-for="plan in currentFloorPlans"
        @click.stop="() => (triggerFloorplanPopup(plan.unit), window.googleAnalytics('floorplan', plan.address))">
        <div class="img-container"><img loading="lazy" :alt="'Image for ' + plan['address'] + ', ' + plan['neighborhood']"
            :src="plan['floor plan']" /></div>
        <div class="floor-item-content">
          <span class="block">{{ plan.address }} </span>
          <span class="block">{{ plan.neighborhood }} </span>
          <!-- <span class="block">${{plan.price}}
                        </span> -->
          <span class="block"> {{ plan.info.replace(/None/g, "—") }} </span>
        </div>
      </button>
      <span v-if="floorplans.length === 0"> No floor plans found</span>
    </div>
    <span class="floorplan-disclaimer">While every attempt is made to ensure accuracy, this floor plan is for guidance
      only. The measurements, dimensions, specifications, and other data shown are approximate and may not be to scale. 
      We assume no responsibility
      for the accuracy of this floor plan or for any action taken in reliance thereon. This floor plan does not create any
      representation, warranty or contract. All parties should consult a professional, such as an architect, to
      verify the information contained herein.</span>
    <div class="btn-container">
      <button id="view-more-floorplans-btn" class="btn-dark tabletSmall:btn-dark-small" @click="showMoreFloorPlans()"
        v-if="currentFloorPlans < floorplans">
        View More
      </button>
    </div>
  </div>
</template>
<script>
import Select from 'primevue/select';
import lightGallery from 'lightgallery';
import { AgGridVue } from 'ag-grid-vue3';
import lgThumbnail from 'lightgallery/plugins/thumbnail';

const testVariantRentalTable = posthog.getFeatureFlag('lines-on-building-pages') == 'lines-on-building-pages-variant';

let ACTIVE_TAB = "ACTIVE SALES";
function openGallery(id, photos = [], index = 0, imagesExist) {
  if(imagesExist){
    const $dynamicGallery = document.getElementById(id);
    const dynamicGallery = lightGallery($dynamicGallery, {
      download: false,
      thumbnail: true,
      dynamic: true,
      speed: 500,
      plugins: [lgThumbnail],
      dynamicEl: photos.map((photo) => ({ src: photo, thumb: photo })),
      licenseKey: window.lightgalleryKey,
    });
    dynamicGallery.openGallery(index);
  }
}

//set height of right bar of header on mobile screen
const parentHeaderHeight = document.getElementsByClassName(
  'mobile-screen-header'
)[0].clientHeight;
const header_right_mobile = document.getElementsByClassName(
  'header-right-mobile'
)[0];
header_right_mobile.style.height = parentHeaderHeight + 'px';

window.addEventListener('load', function() {

});

// window.onload = (_) => {
//   window.googleAnalytics('Building page loaded', window.building_address);
//   window.addInquirySource();
//   new Swiper(".new-developments-slider", {
//     lazy: true,
//     slidesPerView: "auto",
//     spaceBetween: 8,
//     navigation: {
//       nextEl: '.swiper-button-next',
//       prevEl: '.swiper-button-prev',
//     },
//   });
//   // lazy: {
//   //     loadPrevNext: true,
//   //     loadPrevNextAmount: 3
//   // },
// };

//VUE SECTION
import { h } from 'vue';
const NoRowsOverlay = {
  name: 'NoRowsOverlay',
  props: ['params'],
  render() {
    return h('div', {onclick: this.joinWaitlist, style: { pointerEvents: 'all', border: '1px solid black'}, class: 'cursor-pointer p-3'}, [
      h('span', this.activeTabNoRowsMessage()),
    ]);
  },
  methods: {
    joinWaitlist() {
      const { tab } = this.params;
      if(tab === 'ACTIVE SALES' || tab === 'ACTIVE RENTALS') {
        showCustomDialog('join-waitlist-popup');
      };
    },
    activeTabNoRowsMessage() {
      const { tab } = this.params;
      if(tab === 'ACTIVE SALES' || tab === 'ACTIVE RENTALS') {
        return 'Join Waitlist';
      }
      else if(tab === 'SOLD LISTINGS') {
        return 'No sales history';
      }
      return 'No Data';
    },
  }
};
const BedCellRenderer = {
  render() {
    const { beds } = this.params.data;
    return h('div', {
      class: 'flex items-center',
    }, [
      h('span', {
        innerHTML: beds ? beds : 'Studio',
      })
    ]);
  }
};
const StartingPriceCellRenderer = {
  render() {
    const { starting_price } = this.params.data;
    return h('span', {
      innerHTML: `STARTING AT ${this.currencyFormatter(starting_price)}`,
    });
  },
  methods: {
    currencyFormatter(amount) {
      if (amount === undefined || amount === null) return '';
      return '$' + this.formatWithCommas(amount);
    },
    formatWithCommas(value) {
      let stringValue = String(value);
      return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
// range square feet min_sqft: 1342, max_sqft: 1647
const RangeSquareFeetCellRenderer = {
  render() {
    const { min_sqft, max_sqft } = this.params.data;
    return h('span', {
      // if null then show nothing
      innerHTML: min_sqft && max_sqft ? `${min_sqft} - ${max_sqft} sqft` : '',
    });
  },
};
const ThumbnailCellRenderer = {
  render() {
    return h('img', {
      style: {
        backgroundImage: `url(${this.image})`,
        width: '110px',
        height: '78px',
        backgroundAttachment: 'fixed',
        backgroundPosition: 'center bottom',
        backgroundSize: '110px 78px',
        margin: '0px 0px 15px 0px',
        cursor: 'pointer',
      },
      loading: "lazy",
      id: this.params.data.pk,
      'aria-label': this.label,
      onclick: () => {
        openGallery(
          this.params.data.pk,
          this.params.value,
          this.randomIndex,
          this.params.value?.length > 0 ? true : false,
        );
      },
    });
  },
  data: function () {
    let default_photo_url = window.default_img;
    this.randomIndex = this.getRandomInt(this.params?.value?.length);
    default_photo_url = this.params.value?.length
      ? this.params.value[this.randomIndex]
      : window.default_img;
    let label = `Image for ${this.params?.data?.unit}`;
    return {
      image: default_photo_url,
      randomIndex: 0,
      label: label,
    };
  },
  methods: {
    //return random index, so any photo can be selected as random for thumbnail
    getRandomInt(max) {
      return Math.floor(Math.random() * max);
    },
  },
};

const ScheduleVewingCellRenderer = {
  render() {
    return h(
      'div',
      {
        onclick: this.attachCtaValue,
        style: {
          width: '140px',
        },
        class: "btn-light-small border-custom",
        innerHTML: this.params.value || testVariantRentalTable ? 'Schedule Viewing' : 'View',
      },
    );
  },
  methods: {
    getCTAValue() {
      if(window.isAdmin && ACTIVE_TAB === 'ACTIVE RENTALS' && testVariantRentalTable) {
        return  `Line: ${this.params.data?.beds} bedroom`;
      }
      return this.params.data?.cta_value;
    },
    attachCtaValue() {
      showCustomDialog('schedule-viewing-popup');
      // open form popup
      // window.togglePopup(
      //     'form-popup-container',
      //     'close-form-popup-trigger'
      // );
      window.addInquirySource('form_source_schedule_viewing_popup', ACTIVE_TAB);
      const formHiddenInput = document.getElementById(
        'form_listing_id_schedule_viewing_popup'
      );
      if (formHiddenInput) {
        formHiddenInput.value = this.getCTAValue();
      }
      window.googleAnalytics('schedule_viewing', ACTIVE_TAB);
      if(window.isAdmin && ACTIVE_TAB === 'ACTIVE RENTALS') {
        posthog.capture('schedule_view_clicked', {
          variant: posthog.getFeatureFlag('lines-on-building-pages') || 'control',
          location: window.location.host, // optional, helps later with filtering
        });
      }
    },
  },
};
const FloorplanCellRenderer = {
  render() {
    return h('div', {}, [
      h('span', {
        class: 'material-symbols-outlined',
        innerHTML: 'map'
      }),
    ]);
  },
};
const UnitCellRenderer = {
  render() {
    return h('div', {}, [
      h('span', {
        innerHTML: this.params.data?.unit,
        style: { display: 'block' },
      }),
      h('span', {
        innerHTML: this.params.data?.courtesy,
        style: {
          display: 'block',
          fontSize: '10px',
          lineHeight: ' 16px',
        },
      }),
    ]);
  },
};
const PriceCellRenderer = {
  render() {
    return h('div', {}, [
      h('span', {
        innerHTML: this.params.data?.price,
        style: { display: 'block' },
      }),
      h('span', {
        innerHTML:
          this.params.data?.status?.toLowerCase() != 'active'
            ? this.params.data?.status
            : '',
        style: {
          display: 'block',
          fontSize: '10px',
          lineHeight: ' 16px',
        },
      }),
    ]);
  },
};
export default {
  name: 'Building detail Vue App',
  components: {
    NoRowsOverlay,
    BedCellRenderer,
    UnitCellRenderer,
    PriceCellRenderer,
    ThumbnailCellRenderer,
    FloorplanCellRenderer,
    'prime-select': Select,
    'ag-grid-vue': AgGridVue,
    StartingPriceCellRenderer,
    RangeSquareFeetCellRenderer,
    ScheduleVewingCellRenderer,
    'dialog-component': window.dialog_component,
  },
  methods: {
    formatWithCommas(value) {
      let stringValue = String(value);
      return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    openFormPopup(listing) {
      showCustomDialog('schedule-viewing-popup');
      const { unit } = listing;
      const formHiddenInput = document.getElementById(
        'form_listing_id_schedule_viewing_popup'
      );
      if (formHiddenInput) {
        formHiddenInput.value = unit;
      }
    },
    openPlanForm(listing) {
      this.openFormPopup(listing);
      window.googleAnalytics(
        'schedule_viewing',
        this.floorplanPopupTrigger + ' popup'
      );
    },
    openStackingPopup(stack) {
      this.openFloorplanPopup = true;
      this.floorplanPopupTrigger = 'Stacking Plan';
      this.selectedStack = stack;
      window.googleAnalytics('stacking_plan', stack.address + ' ' + stack.unit);
      window.addInquirySource('form_source_schedule_viewing_popup', 'Stacking Plan');
    },
    attachCtaValue(cta_value) {
      //open form popup
      showCustomDialog('schedule-viewing-popup');
      const formSourceInput =
        document.getElementById('form_source_schedule_viewing_popup');
      if (formSourceInput) {
        formSourceInput.value = ACTIVE_TAB;
      }
      const formHiddenInput = document.getElementById(
        'form_listing_id_schedule_viewing_popup'
      );
      if (formHiddenInput) {
        formHiddenInput.value = cta_value;
      }
      window.googleAnalytics('schedule_viewing', ACTIVE_TAB);
    },
    toggleShowImgs(pk) {
      const item = this.rowData.find((row) => row.pk === pk);
      if (item) item.show_all_imgs = true;
    },
    formatNumber(number) {
      return Math.floor(number)
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    },
    currencyFormatter(params) {
      if (params.value === undefined || params.value === null) return '';
      return '$' + this.formatWithCommas(params.value);
    },
    formatNumberWithCommas(num = 0) {
      return num ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '-'
    },
    reformatDateInString(inputString) {
      // Regular expression to match dates in YYYY-MM-DD format
      const dateRegex = /\b(\d{4})-(\d{2})-(\d{2})\b/g;
      const reformattedString = inputString.replace(dateRegex, (match, year, month, day) => {
        return `${month}/${day}/${year}`; // Format as MM/DD/YYYY
      });
      return reformattedString;
    },
    onGridReady(params) {
      this.gridAPI = params.api;
      this.gridColumnAPI = params.columnApi;
      this.gridAPI.sizeColumnsToFit({
        defaultMinWidth: 100,
        columnLimits: [{ key: 'schedule_reviewing', minWidth: 180 }],
      });
    },
    showNoRowsSoldList() {
      this.gridAPI.showNoRowsOverlay();
    },
    fetchStackingPlan() {
      axios
        .get(stacking_url)
        .then((plan) => {
          const tempObject = {};
          plan.data.forEach((data) => {
            if (tempObject[data.floor]) {
              tempObject[data.floor].push(data);
            } else {
              tempObject[data.floor] = [];
              tempObject[data.floor].push(data);
            }
          });
          this.stackingPlan = Object.values(tempObject).sort(
            (a, b) => b[0].floor - a[0].floor
          );
        })
        .finally(() => {
          this.stackingPlanLoading = false;
        });
    },
    fetchRecentAcitivity() {
      axios.get(`${data_url}&type=recent_activity`).then((recentActivity) => {
        const { listings } = recentActivity.data;
        this.recentActivity = listings;
      })
    },
    unitArea(stack = {}) {
      let { square_feet, beds } = stack;
      const baseBoxWidth = 60;
      if (!square_feet) {
      // Fallback square footage based on number of bedrooms
        switch (beds) {
          case "0":
            square_feet = 500; // Studio
            break;
          case "1":
            square_feet = 700;
            break;
          case "2":
            square_feet = 900;
            break;
          case "3":
            square_feet = 1100;
            break;
          default:
            // If bedrooms is empty or unrecognized, default to 1-bedroom size
            square_feet = 700;
        }
      } 
      let boxWidth = square_feet / 10;
      // set minimum boxwidth
      if (boxWidth <= baseBoxWidth) {
        boxWidth = baseBoxWidth;
      }
      return `${boxWidth}px`;
    },

    hideLoadingOverlay() {
      if (this.gridAPI) {
        this.gridAPI.hideOverlay();
      }
    },
    showLoadingOverlay() {
      if (this.gridAPI) {
        this.gridAPI.showLoadingOverlay();
      }
    },

    fetchSalesListings(type, loadType, tabName) {
      const agGrid = document.getElementsByClassName('ag-root')[0];
      if (agGrid) {
        agGrid.role = 'busy';
      }
      this.rowData = [];
      this.gridLoading = true;
      this.$nextTick(() => {
        this.hideLoadingOverlay();
        this.showLoadingOverlay();
      });

      axios.get(`${data_url}&type=${type}`).then((response) => {
        if (agGrid) {
          agGrid.role = 'treegrid';
        }
        const { listings, units_mix } = response.data;
        if(window.isAdmin && testVariantRentalTable && type == 'rentals') {
          this.rowData = units_mix;
        }
        else {
          this.rowData = listings;
        }
        //if ACTIVE SALES response is empty then automatically navigate to ALL UNITS tab
        if (loadType == 'initial_load') {
          if (type == 'sales' && listings.length == 0) {
            this.fetchSalesListings(
              'rentals',
              'initial_load',
              'ACTIVE RENTALS'
            );
          } else if (type == 'rentals' && listings.length == 0) {
            this.fetchSalesListings(
              'units',
              'initial_load',
              'ALL UNITS'
            );
          } else {
            this.activeTab = tabName;
          }
        }
      })
      .finally(() => {
        this.gridLoading = false;
      });
    },
    fetchFloorPlans() {
      axios.get(`${data_url}&type=floor_plans`).then((floorplans) => {
        const { listings } = floorplans.data;
        this.floorplans = listings;
        if (this.floorplans.length > 8) {
          this.currentFloorPlans = this.floorplans.slice(0, 8);
        } else {
          this.currentFloorPlans = this.floorplans;
        }
      });
    },
    showMoreFloorPlans() {
      if (
        this.currentFloorPlans.length +
        this.currentFloorPlans.length +
        8 >
        this.floorplans.length
      ) {
        this.currentFloorPlans = this.floorplans;
      } else {
        this.currentFloorPlans = this.floorplans.slice(
          0,
          this.currentFloorPlans.length + 8
        );
      }
    },
    triggerFloorplanPopup(unit) {
      this.stackingPlan.forEach((plan) => {
        const matchedPlan = plan.find((stack) => stack.unit == unit);
        if (matchedPlan) {
          this.selectedStack = matchedPlan;
          this.openFloorplanPopup = true;
          this.floorplanPopupTrigger = 'Floor Plan';
          window.addInquirySource('form_source_schedule_viewing_popup', 'Floor Plan');
          return;
        }
      });
    },
    //replace $ and , from value to convert it into number format
    localSorter(valueA, valueB) {
      return (
        Number(valueA?.replace(/(\$)|(\,)/gi, '')) -
        Number(valueB?.replace(/(\$)|(\,)/gi, ''))
      );
    },
    stackBGcolor(stack, index) {
      if (this.beds && this.status) {
        if (
          this.beds &&
          Math.floor(this.beds.value) == Math.floor(stack.beds) &&
          this.status == stack.status
        ) {
          return { backgroundColor: '#3f6777' };
        }
      } else if (this.status == stack.status) {
        return { backgroundColor: '#3f6777' };
      } 
      else if (this.beds && this.beds.value === 'studio' && (stack.beds?.toLowerCase() === 'studio' || stack.beds?.toLowerCase() === '0')) {
        return { backgroundColor: '#3f6777' };
      }
      else if (
        this.beds &&
        Math.floor(this.beds.value) == Math.floor(stack.beds)
      ) {
        return { backgroundColor: '#3f6777' };
      }
      return { backgroundColor: index % 2 == 0 ? '#e4eef2' : '#aecfdc' };
    },
    stackContent(stack) {
      if (this.beds && this.status) {
        if (
          this.beds &&
          Math.floor(this.beds.value) == Math.floor(stack.beds) &&
          this.status == stack.status
        ) {
          return {
            fontSize: '12px',
            fontWeight: '600',
            color: '#fff',
          };
        }
      } else if (this.status == stack.status) {
        return { fontSize: '12px', fontWeight: '600', color: '#fff' };
      } else if (
        this.beds &&
        Math.floor(this.beds.value) == Math.floor(stack.beds)
      ) {
        return { fontSize: '12px', fontWeight: '600', color: '#fff' };
      } else {
        return {
          fontSize: '12px',
          fontWeight: 'normal',
          color: 'black',
        };
      }
    },
    handleClickOutsideFloorplan() {
      this.openFloorplanPopup = false;
    },
    openPopupFromURLParams(activeTab, listingId) {
      showCustomDialog('schedule-viewing-popup');
      window.addInquirySource('form_source_schedule_viewing_popup', activeTab);
      const formHiddenInput = document.getElementById(
        'form_listing_id_schedule_viewing_popup'
      );
      if (formHiddenInput) {
        formHiddenInput.value = listingId;
      }
      window.googleAnalytics('schedule_viewing', listingId);
    },
    // Function to parse URL parameters and invoke the openPopupFromURLParams function and return the Tab name (if included)
    checkUrlParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const action = urlParams.get('action');
      let activeTab = urlParams.get('tab');
      const listingId = urlParams.get('listing_id');
      if (activeTab) {
        action === 'popup' && listingId && this.openPopupFromURLParams(activeTab, listingId);
        if (activeTab.includes('Rentals')) {
          activeTab = 'rentals';
        } else if (activeTab.includes('Sold')) {
          activeTab = 'sold';
        } else if (activeTab.includes('Units')) {
          activeTab = 'units';
        } else {
          activeTab = 'sales';
        }
        return activeTab;
      }
      return false;
    },
    setABTesting() {
      posthog.onFeatureFlags(() => {
        const variant = posthog.getFeatureFlag('view-more-button-text-test');
        const btn = document.getElementById('view-more-floorplans-btn');
        if (btn) {
          btn.addEventListener('click', () => {
            posthog.capture('view_more_clicked', { variant });
          });
        }
        if (variant === 'see-more') {
          btn.textContent = 'See More';
        } else {
        }
        // Optional: track which variant was shown
        if (variant) {
          posthog.capture('experiment_view_more_shown', { variant });
        }
     });
    }
  },
  data() {
    return {
      djangoData: {},
      recentActivity: [],
      gridLoading: false,
      listingsColumnDefs: [
        {
          headerName: 'Photos',
          field: 'photos',
          cellRenderer: 'ThumbnailCellRenderer',
          sortable: false,
          maxWidth: 170,
          cellStyle: { marginTop: '8px' },
          valueFormatter: (params) => params?.value,
        },
        {
          headerName: 'Unit',
          field: 'unit',
          maxWidth: 160,
          cellRenderer: 'UnitCellRenderer',
        },
        {
          headerName: 'Price',
          field: 'price',
          maxWidth: 120,
          initialSort: 'desc',
          comparator: this.localSorter,
          cellRenderer: 'PriceCellRenderer',
        },
        { headerName: 'Beds', field: 'beds', maxWidth: 140, valueFormatter: (params) => params?.value },
        { headerName: 'Baths', field: 'baths', maxWidth: 140 },
        {
          headerName: 'Square Feet',
          field: 'square feet',
          maxWidth: 140,
          valueFormatter: (params) => params?.value,
        },
        {
          headerName: window.common_charge_label,
          field: 'common charges/maintenance',
          maxWidth: 140,
          comparator: this.localSorter,
        },
        {
          headerName: 'Property Taxes',
          field: 'property taxes',
          maxWidth: 140,
          comparator: this.localSorter,
        },
        {
          headerName: '',
          field: 'cta_text',
          cellRenderer: 'ScheduleVewingCellRenderer',
          maxWidth: 180,
          sortable: false,
        },
        { headerName: 'Id', field: 'pk', hide: true },
      ],
      openFloorplanPopup: false,
      floorplanPopupTrigger: '',
      status: null,
      statusOptions: ['Active', 'Sold', 'In contract', 'Unlisted'],
      beds: null,
      bedOptions: [
        { name: 'Studio', value: 'studio' },
        { name: '1', value: '1' },
        { name: '2', value: '2' },
        { name: '3', value: '3' },
        { name: '4', value: '4' },
        { name: '5', value: '5' },
      ],
      stackingPlan: [],
      stackingPlanLoading: true,
      selectedStack: {
        floorplanImg: null,
        unitAvailability: null,
        unitName: 'N/A',
        unitBeds: 0,
        unitBaths: 'N/A',
        unitSqFt: 'N/A',
        floor_plan: '/'
      },
      activeTab: 'ACTIVE SALES',
      gridAPI: null,
      gridColumnAPI: null,
      gridDefaultColDef: {
        sortable: true,
        filter: true,
        editable: false,
        resizable: true,
        wrapText: true,
        autoHeight: true,
        cellStyle: {
          fontSize: '13px',
          fontFamily: 'Rawline',
          color: '#000',
          fontWeight: 'normal',
          fontstretch: 'normal',
          fontstyle: 'normal',
        },
      },
      rowData: null,
      currentFloorPlans: [],
      floorplans: [],
    };
  },
  watch: {
    activeTab(newValue) {
      ACTIVE_TAB = newValue;
      if (newValue === 'ACTIVE SALES') {
        this.fetchSalesListings('sales');
        this.gridAPI.setGridOption(
          'columnDefs',
          this.listingsColumnDefs
        );
        this.gridAPI.sizeColumnsToFit();
      } else if (newValue === 'ACTIVE RENTALS') {
        this.fetchSalesListings('rentals');
        let cols = [
          {
            headerName: 'Photos',
            field: 'photos',
            cellRenderer: 'ThumbnailCellRenderer',
            sortable: false,
            maxWidth: 170,
            cellStyle: { marginTop: '8px' },
            valueFormatter: (params) => params?.value,
          },
          {
            headerName: 'Unit',
            field: 'unit',
            maxWidth: 270,
            cellRenderer: 'UnitCellRenderer',
          },
          {
            headerName: 'Price',
            field: 'price',
            maxWidth: 170,
            initialSort: 'desc',
            comparator: this.localSorter,
            cellRenderer: 'PriceCellRenderer',
          },
          { headerName: 'Beds', field: 'beds', maxWidth: 170 },
          { headerName: 'Baths', field: 'baths', maxWidth: 170 },
          {
            headerName: 'Square Feet',
            field: 'square feet',
            maxWidth: 170,
            valueFormatter: (params) => params?.value,
          },
          {
            headerName: '',
            field: 'cta_text',
            cellRenderer: 'ScheduleVewingCellRenderer',
            maxWidth: 180,
            sortable: false,
          },
          { headerName: 'Id', field: 'pk', hide: true },
        ];
        // POSTHOG A/B TESTING FOR LINES ON BUILDING PAGES
        if(window.isAdmin && testVariantRentalTable) {
          // So columns would be bedrooms, starting price, square feet range and schedule button
          cols = [];
          const bedColumn = {
            headerName: 'Bedrooms',
            field: 'beds',
            cellRenderer: 'BedCellRenderer'
          };
          const squareFeetColumn = {
            headerName: 'Square Feet',
            field: 'square feet',
            cellRenderer: 'RangeSquareFeetCellRenderer'
          };
          const scheduleButtonColumn = {
            headerName: '',
            field: 'cta_text',
            cellRenderer: 'ScheduleVewingCellRenderer',
            sortable: false,
          };
          const startingPriceColumn = {
            headerName: 'Price',
            field: 'starting_price',
            cellRenderer: 'StartingPriceCellRenderer'
          };
          cols.push(bedColumn, startingPriceColumn, squareFeetColumn, scheduleButtonColumn);
        }
        this.gridAPI.setGridOption(
          'columnDefs',
          cols
        );
        this.gridAPI.sizeColumnsToFit();
      } else if (newValue === 'SOLD LISTINGS') {
        this.fetchSalesListings('sold');
        const cols = [
          {
            headerName: 'Floor Plan',
            field: 'floor plan',
            cellRenderer: 'FloorplanCellRenderer',
            width: 140,
            sortable: false,
          },
          { headerName: 'Date Sold', field: 'date sold' },
          {
            headerName: 'Price Sold',
            field: 'price sold',
            comparator: this.localSorter,
          },
          { headerName: 'Beds', field: 'beds', maxWidth: 120 },
          { headerName: 'Baths', field: 'baths', maxWidth: 120 },
          {
            headerName: 'Square Feet',
            field: 'square feet',
            maxWidth: 130,
            valueFormatter: (params) => params?.value,
          },
          {
            headerName: 'Unit',
            field: 'unit',
            maxWidth: 120,
            cellRenderer: 'UnitCellRenderer',
          },
          {
            headerName: '',
            field: 'cta_text',
            cellRenderer: 'ScheduleVewingCellRenderer',
            maxWidth: 180,
            sortable: false,
          },
          { headerName: 'Id', field: 'pk', hide: true },
        ];
        this.gridAPI.setGridOption('columnDefs', cols);
        this.gridAPI.sizeColumnsToFit();
      } else {
        this.fetchSalesListings('units');
        const cols = [
          {
            headerName: 'Floor Plan',
            field: 'floor plan',
            cellRenderer: 'FloorplanCellRenderer',
            maxWidth: 200,
            sortable: false,
          },
          {
            headerName: 'Unit',
            field: 'unit',
            cellRenderer: 'UnitCellRenderer',
            maxWidth: 170,
          },
          {
            headerName: 'Last Action',
            field: 'last action',
            sortable: false,
            maxWidth: 300,
          },
          { headerName: 'Beds', field: 'beds', maxWidth: 140 },
          { headerName: 'Baths', field: 'baths', maxWidth: 140 },
          {
            headerName: 'Square Feet',
            field: 'square feet',
            maxWidth: 170,
            valueFormatter: (params) => params?.value,
          },
          {
            headerName: '',
            field: 'cta_text',
            cellRenderer: 'ScheduleVewingCellRenderer',
            sortable: false,
            maxWidth: 180,
          },
          { headerName: 'Id', field: 'pk', hide: true },
        ];
        this.gridAPI.setGridOption('columnDefs', cols);
        this.gridAPI.sizeColumnsToFit();
      }
    },
  },
  computed: {
    gridHeight() {
      if (!this.rowData || this.rowData.length === 0) return '160px';
      else if (this.activeTab == 'ALL UNITS' && this.rowData.length > 25)
        return '1200px';
      const baseTemplateHeight = 97;
      const rowHeight =
        this.activeTab == 'SOLD LISTINGS' ||
          this.activeTab == 'ALL UNITS'
          ? 42
          : 98.5;
      return `${this.rowData.length * rowHeight + baseTemplateHeight}px`;
    },
  },
  created() {
    this.popupParent = document.querySelector('body');
  },
  mounted() {
    setTimeout(() => {
      this.setABTesting();
    }, 3000);
    this.fetchFloorPlans();
    this.fetchStackingPlan();
    this.fetchRecentAcitivity();
    const tabTypeInUrl = this.checkUrlParams();
    const tabName = tabTypeInUrl === 'rentals' ? 'ACTIVE RENTALS' : tabTypeInUrl === 'sales' ? 'ACTIVE SALES' : tabTypeInUrl === 'units' ? 'ALL UNITS' : 'SOLD LISTINGS';
    tabTypeInUrl ? this.fetchSalesListings(tabTypeInUrl, 'initial_load', tabName) : this.fetchSalesListings('sales', 'initial_load', 'ACTIVE SALES');
    document.addEventListener('click', this.handleClickOutsideFloorplan);
    if (window.djangoData) {
      this.djangoData = window.djangoData;
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutsideFloorplan);
  },

}
</script>
<style>
@import "lightgallery/css/lightgallery.css";
@import "lightgallery/css/lg-thumbnail.css";
@import "ag-grid-community/styles/ag-grid.css";
@import "ag-grid-community/styles/ag-theme-alpine.css";
@import "./assets/style.css";
</style>
